import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import { initModal } from 'shared/actions/modal.action';

import {} from 'shared/actions/auth.action';
import UsallyDetail from 'web/components/common/term/UsallyDetail';

import TermContent from 'web/routes/info/TermContent';
import PolicyContent from 'web/routes/info/PolicyContent';
import TermAndPolicy from 'web/routes/info/TermAndPolicy';
import ThoundsSongs from 'web/components/ThoundsSongs';

@connect(state => ({ modal: state.shared.modal }), { initModal })
class UsallyDetailContainer extends Component {
  render() {
    const { modal = {} } = this.props;
    const { data = {} } = modal;
    const { componentName = '' } = data;

    // console.log({ props: this.props });

    let content = null;
    if (componentName === 'term') content = <TermContent />;
    else if (componentName === 'policy') content = <PolicyContent />;
    else if (componentName === 'termandpolicy') content = <TermAndPolicy />;
    else if (componentName === 'thounds') content = <ThoundsSongs />;

    return (
      <Dim onClick={this.props.initModal}>
        {componentName !== 'thounds' ? (
          <UsallyDetail initModal={this.props.initModal}>
            {content}
          </UsallyDetail>
        ) : (
          <ThoundsSongs initModal={this.props.initModal}></ThoundsSongs>
        )}
      </Dim>
    );
  }
}

export default UsallyDetailContainer;
